import { clsx, type ClassValue } from 'clsx'
import { toast } from 'sonner'
import { twMerge } from 'tailwind-merge'

import { queryClient } from './tanstack-query'

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function JSONParseSafe<T = unknown>(json: string): T | null {
  try {
    return JSON.parse(json) as T
  } catch (error) {
    return null
  }
}

function invalidateQueries(keys: string[] | string, qc = queryClient) {
  const keySet = new Set(Array.isArray(keys) ? keys : [keys])
  qc.invalidateQueries({
    predicate: (query) => {
      const hasMatch = keySet.has(query.queryKey[0] as string)
      if (hasMatch) console.log('invalidate', query.queryKey[0])
      return hasMatch
    },
    type: 'all',
    refetchType: 'all',
  })
}

function toastCommonError(msg = 'Terjadi kesalahan') {
  toast.error(msg, {})
}

function formatBytes(bytes: number) {
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  let index = 0
  let size = bytes

  while (size >= 1024 && index < units.length - 1) {
    size /= 1024
    index++
  }

  return `${units[index]}`
}

export { cn, JSONParseSafe, invalidateQueries, toastCommonError, formatBytes }
